import React, { useEffect, useState } from 'react';
import moment from "moment-jalaali";
import { IoIosAddCircleOutline } from "react-icons/io";
import DynamicNavBar from "../../Component/navbars/navbar";
import apiRequests from "../../Component/axios/config/config";
import toast from 'react-hot-toast';

export default function Category() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);
    const [showEditingCategory, setShowEditingCategory] = useState(false);
    const [deletingCategory, setDeletingCategory] = useState(null);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [newName, setNewName] = useState("");
    const [addCategoryModal, setAddCategoryModal] = useState(false);

    const items = [{ icon: <IoIosAddCircleOutline />, label: "افزودن", func: AddModalCategory }];

    const apiLogin = () => {
        setLoading(true);
        apiRequests.get("/api/category/v1/get-all-category")
            .then((res) => {
                setCategories(res.data.data);
            })
            .catch(() => { })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        apiLogin();
    }, []);

    useEffect(() => {
        if (editingCategory) {
            setNewName(editingCategory.Name || "");
        }
    }, [editingCategory]);

    function AddModalCategory() {
        setNewName('');
        setAddCategoryModal(true);
    }

    const closeAddModal = () => {
        setNewName('');
        setAddCategoryModal(false);
    }

    const handleAddSubmit = () => {
        if (!newName) {
            toast.error("نام دسته‌بندی نمی‌تواند خالی باشد.");
            return;
        }

        apiRequests.post("/api/category/v1/create-category", {
            Name: newName
        })
            .then(() => {
                toast.success("دسته‌بندی با موفقیت افزوده شد.");
                closeAddModal();
                apiLogin();
            })
            .catch((error) => {
                console.error("خطا در افزودن دسته‌بندی:", error);
                if (error.response) {
                    toast.error(`خطا: ${error.response.data.message || "افزودن دسته‌بندی با خطا مواجه شد."}`);
                } else {
                    toast.error("ارتباط با سرور برقرار نشد.");
                }
            });
    };

    const formatJalaliDate = (dateString) => {
        if (!dateString) return "نامشخص";
        return moment(dateString).format('jYYYY/jMM/jDD');
    };

    const handleEditClick = (category) => {
        setEditingCategory(category);
        setShowEditingCategory(true);
    };

    const handleEditSubmit = () => {
        if (!newName.trim()) {
            toast.error("نام جدید نمی‌تواند خالی باشد.");
            return;
        }

        apiRequests.put("/api/category/v1/edit-category-by-admin", {
            id: editingCategory?._id,
            Name: newName.trim()
        })
            .then(() => {
                toast.success("دسته‌بندی با موفقیت ویرایش شد.");
                setShowEditingCategory(false);
                setEditingCategory(null);
                setNewName("");
                apiLogin();
            })
            .catch((error) => {
                console.error("خطا در ویرایش:", error);
                toast.error("مشکلی در ویرایش پیش آمد.");
            });
    };

    const closeModal = () => {
        setEditingCategory(null);
        setNewName("");
        setShowEditingCategory(false);
    };

    const handleDeleteClick = (category) => {
        const foundCategory = categories.find(item => item._id === category);
        if (!foundCategory) {
            toast.error("دسته‌بندی معتبر نیست.");
            return;
        }
        setDeletingCategory(foundCategory);
        setShowModalDelete(true);
    };

    const handleConfirmDelete = () => {
        if (!deletingCategory || !deletingCategory._id) {
            toast.error("دسته‌بندی معتبر نیست.");
            return;
        }

        console.log("در حال ارسال درخواست حذف با آی‌دی:", deletingCategory._id);

        apiRequests.delete("/api/category/v1/delete-category", {
            data: {
                categories: [deletingCategory._id]
            }
        })

            .then((res) => {
                console.log("پاسخ موفق از سرور:", res.data);
                toast.success("دسته‌بندی حذف شد.");
                setShowModalDelete(false);
                setDeletingCategory(null);
                apiLogin();
            })
            .catch((error) => {
                console.error("خطا در حذف دسته‌بندی:", error);
                if (error.response) {
                    console.error("پاسخ سرور در صورت خطا:", error.response.data);
                    toast.error(`خطا: ${error.response.data.message || "حذف دسته‌بندی با خطا مواجه شد."}`);
                } else {
                    toast.error("خطایی در ارتباط با سرور رخ داد.");
                }
            });
    };

    const closeDeleteModal = () => {
        setShowModalDelete(false);
        setDeletingCategory(null);
    };

    return (
        <div>
            <div className="px-6 text-3xl">دسته‌بندی‌</div>

            <div className="md:flex md:justify-center">
                <DynamicNavBar items={items}   />

            </div>

            <div className="flex justify-center mt-8">
                <table className="min-w-[80%]">
                    <thead className="bg-secondColor-shade4 text-white text-center">
                        <tr>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tr-lg">نام</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium">وضعیت</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium">ایجاد شده در</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium">ویرایش شده در</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tl-lg">عملیات</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {loading ? (
                            <tr>
                                <td colSpan="6">
                                    <div className="flex justify-center items-center py-8">
                                        <span className="text-blue-500 text-lg">در حال بارگزاری...</span>
                                    </div>
                                </td>
                            </tr>
                        ) : categories.length > 0 ? (
                            categories.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-100 md:text-[8px] text-center">
                                    <td className="px-4 py-2">{item.Name || "نام ثبت نشده"}</td>
                                    <td className="px-4 py-2">{item.isDeleted ? "غیرفعال" : "فعال"}</td>
                                    <td className="px-4 py-2">{formatJalaliDate(item.createdAt)}</td>
                                    <td className="px-4 py-2">{formatJalaliDate(item.updatedAt)}</td>
                                    <td className="px-4 py-2 flex gap-3 justify-center">
                                        <button
                                            className="text-blue-600 hover:underline"
                                            onClick={() => handleEditClick(item)}
                                        >
                                            ویرایش
                                        </button>
                                        <button
                                            className="text-red-600 hover:underline"
                                            onClick={() => handleDeleteClick(item._id)}
                                        >
                                            حذف
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="hover:bg-gray-100 text-center">
                                <td className="px-4 py-2" colSpan="6">دسته‌بندی‌ای یافت نشد!</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* MODAL ویرایش */}
            {showEditingCategory && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
                        <h2 className="text-xl font-bold mb-4 text-center">ویرایش دسته‌بندی</h2>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            placeholder="نام جدید را وارد کنید"
                        />
                        <div className="flex justify-between">
                            <button
                                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                                onClick={handleEditSubmit}
                            >
                                ذخیره
                            </button>
                            <button
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                                onClick={closeModal}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL حذف */}
            {showModalDelete && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg text-center">
                        <h2 className="text-xl font-bold mb-4">حذف دسته‌بندی</h2>
                        <p className="mb-6">
                            آیا از حذف <strong>{deletingCategory?.Name || "این دسته‌بندی"}</strong> مطمئن هستید؟
                        </p>
                        <div className="flex justify-between">
                            <button
                                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                                onClick={handleConfirmDelete}
                            >
                                بله، حذف شود
                            </button>
                            <button
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                                onClick={closeDeleteModal}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL افزودن */}
            {addCategoryModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
                        <h2 className="text-xl font-bold mb-4 text-center">افزودن دسته‌بندی جدید</h2>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            placeholder="نام دسته‌بندی را وارد کنید"
                        />
                        <div className="flex justify-between">
                            <button
                                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                                onClick={handleAddSubmit}
                            >
                                افزودن
                            </button>
                            <button
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                                onClick={closeAddModal}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
